import {
  LinkOutlined,
  LoadingOutlined,
  PhoneOutlined,
} from '@ant-design/icons';
import { Spin } from 'antd';
import React, { memo, useCallback } from 'react';

function WhatsAppPreview({
  variation,
  previewPage = false,
  whatsapp,
  index,
  loading = false,
}) {
  const loadingSpin = <LoadingOutlined style={{ fontSize: 35 }} spin />;

  let bodyText = whatsapp[index]?.bodyText || '';
  const variable = variation?.whatsAppVariables || {};

  const replacedVariables = useCallback(
    (text, object) => {
      for (const key in object) {
        text = text.replace(key, object[key]);
      }
      return text;
    },
    [variable]
  );

  const body = (
    <div className="sms-preview-body">
      <div className="clearfix">
        <div className="sms-preview-message">
          {whatsapp[index]?.headerText && (
            <div
              style={{
                fontWeight: 800,
                color: '#6e707a',
                marginBottom: 4,
              }}
            >
              {whatsapp[index]?.headerText}
            </div>
          )}
          {replacedVariables(bodyText, variable) &&
            replacedVariables(bodyText, variable)
              .split('\n')
              .map((item, i) => (
                <span key={i}>
                  {item}
                  <br />
                </span>
              ))}
          {whatsapp[index]?.footer && (
            <div
              style={{
                color: '#6e707a',
                marginBottom: 4,
              }}
            >
              {whatsapp[index]?.footer}
            </div>
          )}
        </div>
      </div>
      {whatsapp[index]?.templateButtons && (
        <div className="buttons-wrapper" style={{ marginTop: 30 }}>
          {whatsapp[index]?.templateButtons.buttons.map((button, i) => (
            <div key={i} className="btn">
              {button.typeOfAction === 'URL' ? (
                <LinkOutlined />
              ) : button.typeOfAction === 'PHONE_NUMBER' ? (
                <PhoneOutlined />
              ) : (
                ''
              )}
              <span style={{ paddingLeft: 4 }}>{button.text}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <section
      className={`message-container__preview ${
        previewPage ? 'message-container__preview--static' : ''
      } overflow-hidden`}
    >
      <div className="pos-relative w-100 overflow-hidden">
        <div className="preview">
          <div className="preview_sms preview_whatsapp preview_mobile preview_android">
            <div
              id="sms-android"
              className="preview-inner"
              style={{
                margin: 0,
                height: 618,
              }}
            >
              <div className="preview-device empty"></div>
              <div className="preview-device mobile mobile_android"></div>
              <div className="preview-content">
                {loading ? (
                  <div
                    style={{
                      backgroundColor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center',
                      justifyContent: 'center',
                      paddingTop: 50,
                      paddingBottom: 50,
                    }}
                  >
                    <Spin indicator={loadingSpin} />
                  </div>
                ) : (
                  body
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const Memoized = memo(WhatsAppPreview);

export { Memoized as WhatsAppPreview };
